import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { pdfFiles, PDFdownloadButton } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const FamilyRoutinesVideo = () => {
  const pdf = [pdfFiles.strategiesPart1[1], pdfFiles.strategiesPart1[6]];
  return <VideoAndShowPDFAfter vidSrc={1194418676} pdfFile={pdf} />;
};

export default FamilyRoutinesVideo;
